import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import SimpleBar from 'simplebar-react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import { headerSearchDataLoading } from 'store/actions';
import Spinners from 'components/Common/Spinner';
import useDebounce from 'hooks/useDebounce';
const SearchInHeader = props => {
	const [openSearchResults, setOpenSearchResults] = useState(false);
	const [searchKeyWord, setSearchKeyWord] = useState('');
	const [searchResultData, setSearchResultData] = useState([]);
	const SearchProperties = createSelector(
		state => state.Search,
		search => ({
			isLoading: search?.headerSearchDataLoading || false,
			dataValue: search?.headerSearchData || []
		})
	);

	const { isLoading, dataValue } = useSelector(SearchProperties);

	const dispatch = useDispatch();
	const debouncedSearchValue = useDebounce(searchKeyWord, 1000);
	useEffect(() => {
		if (searchKeyWord !== '') {
			//dispatch(headerSearchDataLoading({ searchKey: searchKeyWord }));
		}
	}, [debouncedSearchValue]);

	useEffect(() => {
		if (dataValue.length > 0) {
			//setSearchResultData(dataValue);
		}
	}, [dataValue]);

	return (
		<React.Fragment>
			<Dropdown
				isOpen={openSearchResults}
				toggle={() => setOpenSearchResults(!openSearchResults)}
				className="dropdown d-inline-block"
				tag="li"
			>
				<div className="app-search d-none d-lg-block">
					<div className="position-relative">
						<input
							type="text"
							className="form-control"
							placeholder="Search..."
							value={searchKeyWord}
							onChange={e => {
								setSearchResultData([]);
								setSearchKeyWord(e.target.value);
								if (e.target.value === '') {
									setOpenSearchResults(false);
								} else {
									setOpenSearchResults(true);
								}
							}}
						/>
						<span className="bx bx-search-alt" />
					</div>
				</div>
				<DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
					<div className="p-3">
						<Row className="align-items-center">
							<Col xs="8">
								<h6 className="m-0">
									{' '}
									{props.t('Search Data')}
									{' (' + dataValue.length + ') '}{' '}
								</h6>
							</Col>
							<Col xs="4" className="col-auto text-end">
								<button
									type="button"
									className="btn btn-light btn-sm"
									onClick={() => {
										setOpenSearchResults(false);
										setSearchKeyWord('');
										setSearchResultData([]);
									}}
								>
									{' '}
									Clear
								</button>
							</Col>
						</Row>
					</div>
					<SimpleBar style={{ height: isLoading ? '150px' : '230px' }}>
						{isLoading ? (
							<div className="text-center my-5 text-primary">
								<Spinner />
							</div>
						) : (
							<div>
								{searchResultData && searchResultData.length > 0 ? (
									searchResultData.map((item, index) => {
										return (
											<Link
												key={'search_' + index}
												to={`/booking-details/${item.bookingNumber}`}
												onClick={() => {
													setOpenSearchResults(false);
													setSearchKeyWord('');
												}}
												className="text-reset notification-item"
											>
												<div className="d-flex">
													<div className="avatar-xs me-3">
														<span className="avatar-title bg-primary rounded-circle font-size-16">
															<i className="bx bx-search" />
														</span>
													</div>
													<div className="flex-grow-1">
														<h6 className="font-size-12 mt-0 mb-1"> Booking # {item?.bookingNumber}</h6>
														<p className="font-size-10 mb-1"> {item?.description} </p>
													</div>
												</div>
											</Link>
										);
									})
								) : (
									<div className="text-center p-3">No Result Found</div>
								)}
							</div>
						)}
					</SimpleBar>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default withTranslation()(SearchInHeader);

SearchInHeader.propTypes = {
	t: PropTypes.any
};
